import React from 'react'
import {
  Chart as ChartJS,
  registerables
} from 'chart.js/auto'

import { Line } from "react-chartjs-2"
import { FetchSaleStatistics } from '../../types';

ChartJS.register(
  ...registerables
);

const options = {
  scales: {
    y: {
      beginAtZero: true,
      suggestedMin: 0,
      grid: {
        display: false,
      },
      ticks: {
        min: 0,
        stepSize: 100
      }
    },
    x: {
      grid: {
        display: false,
      }
    },
  }
}

const SalesChart = ({ dataSaleStatistics }: { dataSaleStatistics: FetchSaleStatistics }) => {
  const labels = dataSaleStatistics?.saleStatisticsStore.map(entry => entry.day.split('-')[2])//.reverse();

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Sales",
        backgroundColor: "#7951F9",
        borderColor: "#7951F9",
        data: dataSaleStatistics?.saleStatisticsStore.map(entry => entry.totalSales),
        tension: 0.5
      },
    ],
  };

  return (
    <Line dir='ltr' data={data} options={options} />
  )
}

export default SalesChart